'use strict';

var React = require('react');
var TabPane_styles = require('./TabPane.styles.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

const TabPane = React.forwardRef(({ activeTab, tab, children, keepMounted = false, ...props }, ref) => {
    const isActive = activeTab === tab;
    return isActive || keepMounted ? (React__default.default.createElement(TabPane_styles.StyledTabPane, { ...props, ref: ref, hide: !isActive, role: "tabpanel", "aria-hidden": !isActive, "aria-labelledby": `tab_${tab}` }, children)) : null;
});

exports.TabPane = TabPane;
//# sourceMappingURL=TabPane.js.map
